var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 22",
    width: 24,
    height: 22,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "usdt") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #50af95 } \n\t\t.s1 { fill: #ffffff } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "s0",
    d: "m5.7 2.1l-3.7 7.9q0 0.1 0 0.2l9.9 9.8c0.1 0 0.1 0 0.2 0l9.9-9.8q0-0.1 0-0.2l-3.7-7.9q0-0.1-0.1-0.1h-12.4q-0.1 0-0.1 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "s1",
    d: "m18.2 9.8c0 0.7-2.1 1.3-4.9 1.5v5h-2.6v-5c-2.8-0.2-4.9-0.8-4.9-1.5 0-0.7 2.1-1.2 4.9-1.4v-1.5h-3.4v-2.4h9.5v2.4h-3.5v1.5c2.8 0.2 4.9 0.7 4.9 1.4zm-0.6-0.1c0-0.5-1.8-1-4.3-1.1v1.8c-0.1 0-0.5 0-1.3 0-0.6 0-1.1 0-1.3 0v-1.8c-2.5 0.1-4.3 0.6-4.3 1.1 0 0.6 1.8 1 4.3 1.1 0.2 0 0.7 0.1 1.3 0.1 0.8 0 1.2-0.1 1.3-0.1 2.5-0.1 4.3-0.5 4.3-1.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.22c21cfd738a0940443bf4e673585cff.svg";
export { ForwardRef as ReactComponent };